export default __webpack_public_path__ + "static/media/port-brasil.51622081.webp";